/**
 * Created by karthikeyan.k on 30-11-2018.
 */
export class GameTypeConstant {
  public static get RNG(): string {
    return 'rng';
  }

  public static get LIVEDEALER(): string {
    return 'livedealer';
  }

  public static get PRIVATEFRIENDS(): string {
    return 'privatefriends';
  }

  public static get LOBBY(): string {
    return 'lobby';
  }
}
